export const reviewsSelector = (state: any) => state.reviews;
